// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"44e8cef6","455":"d25243ec","977":"c65c2e12"}[chunkId] + ".chunk.js";
};